import {
  faArrowLeft,
  faArrowRight,
  faClone,
  faTrashAlt,
} from "@fortawesome/pro-regular-svg-icons";

import { ContextMenu } from "src/decisionTableNode/ContextMenu";
import { MatrixTableActions } from "src/matrixTableNode/utils";

export const ColumnContextMenu = ({
  show,
  index,
  actions,
}: {
  show: boolean;
  index: number;
  actions: MatrixTableActions;
}) => {
  return (
    <ContextMenu button="horizontal" show={show}>
      <ContextMenu.Item
        icon={faArrowLeft}
        onClick={() => actions.insertColumn(index - 1)}
      >
        Insert Left
      </ContextMenu.Item>
      <ContextMenu.Item
        icon={faArrowRight}
        onClick={() => actions.insertColumn(index)}
      >
        Insert Right
      </ContextMenu.Item>
      <ContextMenu.Item
        icon={faClone}
        onClick={() => actions.insertColumn(index - 1, true)}
      >
        Duplicate
      </ContextMenu.Item>
      <ContextMenu.Item
        icon={faTrashAlt}
        onClick={() => actions.deleteColumn(index - 1)}
      >
        Delete column
      </ContextMenu.Item>
    </ContextMenu>
  );
};
